import * as CubeTree from '../../../cubeTree/index';
import { shelfInsertAfter } from './shelf';
import { freezerInsertAfter } from './freezer';
import { partitionInsertAfter } from './partition';
import { goodsInsertAfter } from './goods';
import { textareaInsertAfter } from './textarea';
import { bafflePlateInsertAfter } from './bafflePlate';

function insertAfter(beAddedCube: CubeNode, task: InsertInfo): void {
    if (CubeTree.isShelf(beAddedCube.id)) {
        shelfInsertAfter(beAddedCube, task);
    }
    else if (CubeTree.isFreezer(beAddedCube.id)) {
        freezerInsertAfter(beAddedCube, task);
    }
    else if (CubeTree.isPartition(beAddedCube.id)) {
        partitionInsertAfter(beAddedCube, task);
    }
    else if (CubeTree.isGoods(beAddedCube.id)) {
        goodsInsertAfter(beAddedCube, task);
    }
    else if (CubeTree.isTextarea(beAddedCube.id)) {
        textareaInsertAfter(beAddedCube, task);
    }
    else if (CubeTree.isBafflePlate(beAddedCube.id)) {
        bafflePlateInsertAfter(beAddedCube, task);
    }
}

export {
    insertAfter
};
